export const AppConstants = {
    apiScopes: "api://utilities/managefunctionapp"
}

export default AppConstants;